import { Component, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { filter } from "rxjs/operators"
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { BasketService } from '../../../../../basket/shared/basket.service'
import { ArticleGenerique } from '../../../../../delivery/shared/article-generique/article-generique'
import { ClientService } from "../../../../../shared/client/client.service"
import { Change } from '../../../../../shared/client/contrat/changes'
import { ContratService } from '../../../../../shared/client/contrat/contrat.service'
import { Taille } from '../../../../../shared/client/contrat/taille'
import { SideBarService } from '../../../../../shared/sidebar/side-bar.service'
import { ArticlePorteur } from "../../../shared/articles/article"
import { Porteur } from '../../../shared/porteur'
import { PorteurService } from "../../../shared/porteur.service"
import { typeFamille } from "../card-article/famille"
import { logos } from "../card-article/logos"

@Component({
  selector: 'app-add-article',
  templateUrl: './add-article.component.html',
  styleUrls: ['./add-article.component.scss']
})
export class AddArticleComponent implements OnInit {

  addArticleForm: UntypedFormGroup = new UntypedFormGroup({
    'article': new UntypedFormControl(undefined, [
      Validators.required
    ]),
    'change': new UntypedFormControl(undefined, [
      Validators.required
    ]),
    'taille': new UntypedFormControl(undefined, [
      Validators.required
    ]),
    'comment': new UntypedFormControl(undefined, [
    ]),
    'qteSouhaite': new UntypedFormControl(undefined, [
    ]),
    'retouche': new UntypedFormControl(undefined, [
    ]),
  })

  articles: Array<ArticleGenerique> = new Array<ArticleGenerique>()
  tailles: Array<Taille> = new Array<Taille>()
  changes: Array<Change> = new Array<Change>()
  loadTaille: Subscription = new Subscription()
  loadChange: Subscription = new Subscription()
  porteur: Porteur
  typeFamille = typeFamille
  articleLoaded: ArticlePorteur
  selected_value = null

  retouches = [
    "-3 cm",
    "-6 cm",
    "-9 cm",
    "-12 cm"
  ];

  constructor(
    private contratService: ContratService,
    private route: ActivatedRoute,
    private router: Router,
    private basketService: BasketService,
    private notificationService: NotificationService,
    protected sideBarService: SideBarService,
    private porteurService: PorteurService,
    private clientService: ClientService
  ) { }

  ngOnInit() {
    this.route.parent.parent.data.subscribe(data => {
      this.porteur = data.porteur
    })

    this.contratService.getArticleVT(this.porteur.codeService).subscribe(articles => {
      this.articles = articles
    })

    this.article.valueChanges.pipe(filter(article => article != null)).subscribe(article => {
      this.clearTailles()
      this.clearChanges()
      this.loadChanges()
      this.loadTailles()
      this.articleLoaded = article
    })
  }

  getSvg(): string {
    let pictoFamille = this.findTypeFamille()
    if (pictoFamille) {
      return logos[pictoFamille['type']]
    }
  }

  findTypeFamille() {
    let cle_ref = this.articleLoaded.famille.cle_ref.toString()
    let pictoFamille
    let breakIt = false
    for (let type of this.typeFamille) {
      for (let article of type['articles']) {
        if (cle_ref.match(article['famille']) || article['famille'] == cle_ref) {
          if (this.articleLoaded.code_article.match(article['code'])) {
            pictoFamille = type
            breakIt = true
            break
          }
        }
      }
      if (breakIt === true) {
        break
      }
    }
    return pictoFamille
  }

  private clearTailles() {
    this.tailles = new Array<Taille>()
    this.addArticleForm.get('taille').reset()
  }

  private clearChanges() {
    this.changes = new Array<Change>()
    this.addArticleForm.get('change').reset()
  }

  private loadTailles() {
    this.loadTaille = this.contratService.getTailles(this.article.value, this.porteur.codeService).subscribe((tailles: Taille[]) => {
      this.tailles = tailles
      this.taille.setValue(this.tailles[0])
    })
  }

  private loadChanges() {
    this.loadChange.unsubscribe()

    this.loadChange = this.contratService.getChanges(this.article.value, this.porteur.codeService).subscribe(changes => {
      this.changes = changes
      this.change.setValue(undefined)
    })
  }

  get article(): AbstractControl {
    return this.addArticleForm.get('article')
  }

  get change(): AbstractControl {
    return this.addArticleForm.get('change')
  }

  get taille(): AbstractControl {
    return this.addArticleForm.get('taille')
  }

  get comment(): AbstractControl {
    return this.addArticleForm.get('comment')
  }

  get retouche(): AbstractControl {
    return this.addArticleForm.get('retouche');
  }

  success() {
    this.notificationService.notif("Votre demande d'ajout d'article a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif")
    this.closeSlideBar()
  }

  closeSlideBar() {
    this.router.navigate([
      {
        outlets: {
          sidebar: null,
          basket: null
        }
      }], {
      relativeTo: this.route.parent
    }).then(res => {
      this.sideBarService.close()
    }, error => {

    })
  }

  submitForm() {
    if (this.addArticleForm.get('qteSouhaite').hasError('required')) {
      this.notificationService.notif('Vous devez renseigner la quantité souhaitée car la règle de facturation est de type Stock ou Réel', 'error')
    } else {
      if (undefined !== this.porteur && this.addArticleForm.valid) {
        this.basketService.addBasketLine({
          type: "AJOUT ARTICLE",
          numPorteur: this.porteur.numPorteur,
          article: this.article.value.code_article,
          newChange: this.change.value.qte_semaine + "/" + this.change.value.qte_prevue + "|" + this.change.value.multi_change,
          newTaille: this.addArticleForm.get('taille').value.cle_ref,
          comment: this.comment.value,
          codeService: this.clientService.modifCodeService,
          qteSouhaite: this.addArticleForm.get('qteSouhaite').value,
          regleFactu: this.change.value.type_facturation.cle_ref,
          retouche: this.retouche.value
        }).subscribe(res => this.success())
      }
    }
  }

  private getCurrIndex(): number {
    return this.tailles.indexOf(this.taille.value)
  }

  inc() {
    let index = this.getCurrIndex()
    if (index !== null && this.tailles[index + 1] !== undefined) {
      this.taille.setValue(this.tailles[index + 1])
    }

  }

  dec() {
    let index = this.getCurrIndex()
    if (index !== null && this.tailles[index - 1] !== undefined) {
      this.taille.setValue(this.tailles[index - 1])
    }
  }

  facturationTypeSB() {
    if (this.change.value) {
      if (this.change.value.type_facturation.cle_ref == 'S' || this.change.value.type_facturation.cle_ref == 'B') {
        this.addArticleForm.controls["qteSouhaite"].setValidators([Validators.required])
        return true
      } else {
        this.addArticleForm.get('qteSouhaite').setValue(null)
        this.addArticleForm.controls["qteSouhaite"].clearValidators()
        return false
      }
    } else {
      this.addArticleForm.get('qteSouhaite').setValue(null)
      this.addArticleForm.controls["qteSouhaite"].clearValidators()
      return false
    }
  }

  editDotationForm: UntypedFormGroup = new UntypedFormGroup({
    'qteSouhaite': new UntypedFormControl('', [])
  })
}
